import { useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { ShieldCheck } from "lucide-react";
import { LogoMark } from "../components/Logo";

export default function AdminLogin() {
  const location = useLocation();
  const error = location.state?.error;

  const login = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="relative flex min-h-screen items-center justify-center px-5 pt-20" data-testid="admin-login-page">
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_50%_40%,rgba(225,29,72,0.15),transparent_60%)]" />
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }} className="relative w-full max-w-md border border-rose-900/40 bg-[#0d0c11] p-10">
        <LogoMark size={48} />
        <p className="eyebrow mb-3 mt-8">Área restrita</p>
        <h1 className="font-serif-d mb-4 text-4xl font-semibold text-white">Painel do <span className="italic text-rose-500">administrador</span></h1>
        <p className="mb-8 text-sm leading-relaxed text-slate-300">Somente a conta Google autorizada pode entrar e publicar vídeos e fotos.</p>
        {error && <p className="mb-6 border border-rose-700 bg-rose-950/50 p-3 text-sm text-rose-200" data-testid="admin-login-error">{error}</p>}
        <button onClick={login} data-testid="admin-google-login-button" className="flex w-full items-center justify-center gap-3 bg-white px-6 py-4 text-sm font-semibold text-black transition-colors hover:bg-rose-500 hover:text-white">
          <svg width="18" height="18" viewBox="0 0 48 48"><path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.7 29.2 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.4-.4-3.5z"/><path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z"/><path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.2 35.1 26.7 36 24 36c-5.2 0-9.6-3.3-11.3-8l-6.5 5C9.5 39.6 16.2 44 24 44z"/><path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.2-4.1 5.6l6.2 5.2C37 39.2 44 34 44 24c0-1.3-.1-2.4-.4-3.5z"/></svg>
          Entrar com Google
        </button>
        <p className="mt-6 flex items-center gap-2 text-xs text-slate-400"><ShieldCheck size={14} className="text-rose-400" /> Visitantes não precisam de conta.</p>
      </motion.div>
    </div>
  );
}
